export enum TrafficSortingCharacteristicsType {
  straight,
  left,
  right,
  enterRoundAbout
}



// WEBPACK FOOTER //
// ./src/app/models/enums/trafficsortingcharacteristicstype.ts